import Vue from 'vue'
import App from './App.vue'
import moment from 'moment'
import router from './router'
import store from './store/index'
import './registerServiceWorker'
import '@babel/polyfill'
// import VueSweetalert2 from 'vue-sweetalert2'
import VueI18n from 'vue-i18n'
// import VueCookie from 'vue-cookie'
import Vue2TouchEvents from 'vue2-touch-events'
import loadLocaleMessages from './i18n'
// import VueLodash from 'vue-lodash'
// import VueOffline from 'vue-offline'

// Vue.use(VueOffline)
// Vue.use(VueLodash, {
//   name: 'lodash'
// })
Vue.use(Vue2TouchEvents)
// Vue.use(VueCookie)
Vue.use(VueI18n)
// Vue.use(VueSweetalert2)

Vue.prototype.$moment = moment
Vue.config.productionTip = false

const i18n = new VueI18n({
  locale: 'ko',
  messages: loadLocaleMessages()
})

const EventBus = new Vue()
Object.defineProperties(Vue.prototype, {
  $eventBus: {
    get: function () {
      return EventBus
    }
  }
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
